import React from "react";
import { formatDate } from "./formatDate";

const TH_CLASS = "font-main px-2 sm:px-4 py-2 text-left text-xs sm:text-sm text-black font-[700] whitespace-nowrap";
const TD_CLASS = "font-main px-2 sm:px-4 py-2 text-gray-700";

export default function DashboardUsersTable({
  title,
  users = [],
  emptyMessage = "No users found",
  rowHoverClass = "hover:bg-gray-50",
}) {
  return (
    <div className="w-full rounded-lg overflow-hidden">
      <h2 className="font-main text-base sm:text-lg font-semibold text-red-500 pb-2 mb-3 sm:mb-4">
        {title}
      </h2>
      {users?.length > 0 ? (
        <div className="overflow-x-auto -mx-1 sm:mx-0 rounded-lg border border-gray-200">
          <table className="min-w-[720px] lg:min-w-0 w-full border-collapse text-xs sm:text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className={TH_CLASS}>First Name</th>
                <th className={TH_CLASS}>Last Name</th>
                <th className={`${TH_CLASS} max-w-[120px] sm:max-w-[160px] truncate`}>Email</th>
                <th className={TH_CLASS}>Contact</th>
                <th className={TH_CLASS}>Gender</th>
                <th className={TH_CLASS}>Created Date</th>
                <th className={`${TH_CLASS} text-center`}>Source</th>
                <th className={TH_CLASS}>Status</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr
                  key={user.id ?? index}
                  className={`font-main border-t border-gray-200 ${rowHoverClass}`}>
                  <td className={`${TD_CLASS} whitespace-nowrap`}>{user.firstName ?? "—"}</td>
                  <td className={`${TD_CLASS} whitespace-nowrap`}>{user.lastName ?? "—"}</td>
                  <td className={`${TD_CLASS} max-w-[120px] sm:max-w-[160px] truncate`}>
                    {user.email ?? "—"}
                  </td>
                  <td className={`${TD_CLASS} whitespace-nowrap`}>{user.contactNo ?? user.contact_no ?? "—"}</td>
                  <td className={`${TD_CLASS} whitespace-nowrap`}>{user.gender ?? "—"}</td>
                  <td className={`${TD_CLASS} whitespace-nowrap`}>
                    {formatDate(user.createdDate ?? user.created_date)}
                  </td>
                  <td className="px-2 sm:px-4 py-2 text-center">
                    <span
                      className={`inline-flex px-2 py-0.5 text-xs font-semibold rounded-full border ${
                        (user.is_web ?? user.isWeb) === 1
                          ? "bg-blue-100 text-blue-800 border-blue-200"
                          : "bg-green-100 text-green-800 border-green-200"
                      }`}>
                      {(user.is_web ?? user.isWeb) === 1 ? "Web" : "Mobile"}
                    </span>
                  </td>
                  <td className={TD_CLASS}>
                    {(() => {
                      const active = user.isActive ?? user.is_active;
                      if (active === 1) return <span className="text-green-600 font-medium">Active</span>;
                      if (active === 0) return <span className="text-gray-500">Inactive</span>;
                      return <span className="text-gray-400">—</span>;
                    })()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500 text-sm font-main">{emptyMessage}</p>
      )}
    </div>
  );
}
